import { useEffect, useRef, useState } from 'react';
import { ApiError } from './api';
import { absoluteTime } from './presentation';

/** Aynı sorgu yenilenirken eski veri korunur; başka kayda geçince temizlenir. */
export function useAsync<T>(fn: () => Promise<T>, deps: unknown[] = []) {
  const [data, setData] = useState<T | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const lastSuccess = useRef<number | null>(null);
  const sequence = useRef(0);
  const reload = () => {
    const id = ++sequence.current;
    setLoading(true);
    fn()
      .then((d) => {
        if (id !== sequence.current) return;
        setData(d);
        setErr(null);
        lastSuccess.current = Date.now();
      })
      .catch((e) => {
        if (id !== sequence.current) return;
        const message = e instanceof ApiError ? `${e.code}: ${e.message}` : String(e);
        setErr(
          lastSuccess.current
            ? `Yenilenemedi. ${absoluteTime(lastSuccess.current)} tarihli veri gösteriliyor. ${message}`
            : message,
        );
      })
      .finally(() => {
        if (id === sequence.current) setLoading(false);
      });
  };
  useEffect(() => {
    setData(null);
    setErr(null);
    lastSuccess.current = null;
    reload();
    return () => {
      ++sequence.current;
    };
  }, deps);
  return { data, err, loading, reload, updatedAt: lastSuccess.current };
}
